import WujieVue from 'wujie-vue3';

import type { Bus } from '@celerdata/host-bridge-contract';

const { bus } = WujieVue;

// Centralizes wujie-vue3 access: sub-broadcaster and any future host-sdk
// module pick up the shared bus singleton through this getter instead of
// re-importing wujie-vue3.
export function getSubBus(): Bus {
  return bus as Bus;
}
